import InfoCircle from "@untitled-ui/icons-react/build/esm/InfoCircle";
import styled from "styled-components";
import Close from "../../../../assets/icons/x-close.svg";
import Logo from "../../../../assets/images/logo.png";
import noImage from "../../../../assets/images/no-image.png";
import BtnLargeSolid from "../../../common/buttons/BtnLargeSolid";
import CheckboxVector from "../../../common/checkbox/CheckboxVector";

// #region SCOPED CSS
const StyledReorderSupplyBreakdown = styled.div`
    .supply-popup,
    .supply-popup * {
        box-sizing: border-box;
    }

    .supply-popup {
        --popup-background: var(--backgrounds-and-lines-n-400, #1e2631);
        --popup-surface: var(--backgrounds-and-lines-n-500, #141922);
        --popup-line: var(--backgrounds-and-lines-n-200, #262e3e);
        --popup-text: var(--text-and-icons-gray-100, #d1d1d1);
        --popup-green: var(--text-and-icons-green-500, #00bb00);
        --popup-blue: var(--text-and-icons-blue-500, #00aeef);
        --popup-title-accent: var(--ai-popup-title, #7763fe);
        background: var(--popup-background);
        border-radius: 4px;
        box-shadow: var(--drop-shadow-200-box-shadow, 0 0 48.1px 0 rgba(17, 22, 32, 0.51));
        display: flex;
        flex-direction: column;
        gap: 16px;
        align-items: center;
        justify-content: flex-start;
        width: min(683px, calc(100vw - 48px));
        overflow: visible;
        padding: 58px 26px 34px;
        position: relative;
    }

    .popup-logo {
        border-radius: 9999px;
        width: 72px;
        height: 72px;
        position: absolute;
        left: 50%;
        top: -34px;
        transform: translateX(-50%);
    }

    .close-button {
        background: transparent;
        border: 0;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 32px;
        height: 32px;
        padding: 0;
        position: absolute;
        right: 7px;
        top: 7px;
    }

    .close-button img {
        width: 16px;
        height: 16px;
    }

    .popup-header,
    .popup-body,
    .need-section,
    .product-section,
    .source-section,
    .decision-section {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;
    }

    .popup-header {
        gap: 14px;
    }

    .popup-kicker {
        color: var(--popup-title-accent);
        font-size: 10px;
        font-weight: 500;
        line-height: normal;
        text-align: center;
        text-transform: uppercase;
    }

    .header-divider,
    .section-divider {
        background: var(--popup-line);
        height: 1px;
        width: 100%;
    }

    .popup-body {
        gap: 14px;
    }

    .need-section {
        gap: 10px;
    }

    .need-summary {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        color: #ffffff;
        font-size: 14px;
        font-weight: 400;
        line-height: 17px;
        width: max-content;
    }

    .summary-value {
        color: var(--popup-green);
        font-weight: 600;
    }

    .product-section {
        gap: 17px;
    }

    .product-summary {
        background: var(--popup-surface);
        border-radius: 10px;
        box-shadow: 0 4px 34px 0 rgba(25, 31, 38, 1);
        display: flex;
        flex-direction: row;
        gap: 16px;
        align-items: center;
        justify-content: center;
        min-height: 42px;
        padding: 6px 10px;
    }

    .product-image {
        border-radius: 4px;
        flex-shrink: 0;
        width: 28px;
        height: 28px;
        object-fit: cover;
    }

    .product-details {
        display: flex;
        flex-direction: row;
        gap: 22px;
        align-items: center;
        color: var(--popup-text);
        font-size: 14px;
        font-weight: 400;
    }

    .helper-text {
        color: var(--popup-text);
        font-size: 11px;
        font-weight: 400;
        line-height: normal;
        margin: 0;
        text-align: center;
        width: 100%;
    }

    .table-scroll {
        width: 100%;
        overflow-x: auto;
    }

    .table-scroll > * {
        margin: 0 auto;
    }

    .source-section {
        gap: 8px;
    }

    .section-label {
        color: var(--popup-text);
        font-size: 10px;
        font-weight: 400;
        line-height: normal;
        text-align: center;
        text-transform: uppercase;
    }

    .supply-table {
        --label-column-width: 108px;
        --table-header-height: 34px;
        --table-row-height: 32px;
        --table-column-template: 85px 85px 85px;
        display: grid;
        grid-template-columns: var(--label-column-width) auto;
        justify-content: center;
        width: max-content;
    }

    .supply-table--source-stores {
        --label-column-width: 217px;
        --table-column-template: 86px 86px 86px 44px;
    }

    .supply-table__labels {
        display: flex;
        flex-direction: column;
        padding-top: var(--table-header-height);
    }

    .supply-table__label-row {
        color: var(--popup-text);
        display: flex;
        align-items: center;
        justify-content: flex-end;
        min-height: var(--table-row-height);
        padding-right: 24px;
        font-size: 14px;
        font-weight: 400;
        line-height: normal;
        text-align: right;
        white-space: nowrap;
    }

    .supply-table__matrix {
        background: var(--popup-surface);
        border-radius: 4px;
        display: flex;
        flex-direction: column;
        overflow: hidden;
    }

    .supply-table__header,
    .supply-table__row {
        display: grid;
        grid-template-columns: var(--table-column-template);
    }

    .supply-table__header {
        border-bottom: 1px solid var(--popup-line);
        min-height: var(--table-header-height);
    }

    .supply-table__row {
        min-height: var(--table-row-height);
    }

    .supply-table__cell {
        color: var(--popup-text);
        display: flex;
        align-items: center;
        justify-content: center;
        min-width: 0;
        font-size: 14px;
        font-weight: 400;
        line-height: normal;
        text-align: center;
    }

    .supply-table__cell--header {
        color: var(--popup-blue);
    }

    .supply-table__cell--footer {
        border-top: 1px solid var(--popup-line);
    }

    .supply-table__cell-value--badge {
        background: var(--popup-background);
        border-radius: 5px;
        color: var(--popup-green);
        display: flex;
        align-items: center;
        justify-content: center;
        min-width: 28px;
        height: 26px;
        padding: 0 7px;
    }

    .supply-table__cell--status {
        color: var(--popup-green);
        font-weight: 600;
    }

    .supply-table__cell--info {
        color: var(--popup-text);
    }

    .source-info-icon {
        width: 16px;
        height: 16px;
    }

    .decision-section {
        gap: 22px;
    }

    .request-options {
        display: flex;
        flex-direction: row;
        gap: 52px;
        align-items: center;
        justify-content: center;
        width: 100%;
    }

    .request-option {
        color: var(--popup-text);
        display: flex;
        flex-direction: row;
        gap: 8px;
        align-items: center;
        justify-content: center;
        font-size: 15px;
        font-weight: 400;
        line-height: normal;
        white-space: nowrap;
    }

    .footer-actions {
        display: flex;
        flex-direction: row;
        gap: 8px;
        align-items: center;
        justify-content: center;
        flex-wrap: wrap;
    }

    @media (max-width: 640px) {
        .supply-popup {
            width: calc(100vw - 24px);
            padding-inline: 16px;
        }

        .request-options {
            gap: 12px;
            align-items: flex-start;
            flex-direction: column;
        }
    }
`;
// #endregion

// #region GLOBALS
const SUPPLY_SUMMARY = [
    { label: "Calculated need", value: "14 units" },
    { label: "Available from your stores", value: "6 units" },
    { label: "Need from supplier", value: "8 units" }
];

const PRODUCT_SUMMARY = {
    imageUrl: noImage,
    name: "Type",
    reference: "901402"
};

const SUPPLY_BREAKDOWN_COLUMNS = [
    { key: "need", label: "Need" },
    { key: "internal", label: "Internal", highlight: "badge" },
    { key: "supplier", label: "Supplier" }
];

const SUPPLY_BREAKDOWN_ROWS = [
    { label: "Earth / 43", values: { need: 3, internal: 2, supplier: 1 } },
    { label: "Earth / 44", values: { need: 3, internal: 0, supplier: 3 } },
    { label: "Earth / 45", values: { need: 4, internal: 4, supplier: 0 } },
    { label: "Earth / 46", values: { need: 2, internal: 0, supplier: 2 } },
    { label: "Navy / 46", values: { need: 2, internal: 0, supplier: 2 } }
];

const SUPPLY_BREAKDOWN_TOTALS = {
    label: "TOTAL",
    values: { need: 14, internal: 6, supplier: 8 }
};

const SOURCE_STORE_COLUMNS = [
    { key: "available", label: "Available" },
    { key: "suggested", label: "Suggested" },
    { key: "status", label: "Status", type: "status" },
    { key: "info", label: "", type: "info" }
];

const SOURCE_STORE_ROWS = [
    {
        label: "Ferner Jacobsen Fredrikstad",
        values: { available: 6, suggested: 6, status: "Safe" },
        showInfo: true
    }
];
// #endregion

export default function ReorderSupplyBreakdown({ handleClosePopup = () => {} }) {
    // #region METHODS
    function handleImageFallback(event) {
        event.currentTarget.onerror = null;
        event.currentTarget.src = noImage;
    }

    function handleApplyClick() {
        return undefined;
    }
    // #endregion

    // #region RENDER
    return (
        <StyledReorderSupplyBreakdown>
            <div className="supply-popup" role="dialog" aria-modal="true" aria-labelledby="supply-popup-title">
                <img className="popup-logo" src={Logo} alt="BOtag" />
                <button
                    className="close-button"
                    type="button"
                    onClick={handleClosePopup}
                    aria-label="Close reorder supply breakdown">
                    <img src={Close} alt="" />
                </button>

                <header className="popup-header">
                    <div className="popup-kicker" id="supply-popup-title">
                        REORDER SUPPLY BREAKDOWN
                    </div>
                    <div className="header-divider"></div>
                </header>

                <main className="popup-body">
                    <section className="need-section" aria-label="Supply summary">
                        <div className="need-summary">
                            {SUPPLY_SUMMARY.map(item => (
                                <div className="summary-line" key={item.label}>
                                    {item.label}: <span className="summary-value">{item.value}</span>
                                </div>
                            ))}
                        </div>
                    </section>

                    <div className="section-divider"></div>

                    <section className="product-section">
                        <div className="product-summary" aria-label="Reorder product">
                            <img
                                className="product-image"
                                src={PRODUCT_SUMMARY.imageUrl}
                                onError={handleImageFallback}
                                alt=""
                            />
                            <div className="product-details">
                                <span>{PRODUCT_SUMMARY.name}</span>
                                <span>{PRODUCT_SUMMARY.reference}</span>
                            </div>
                        </div>

                        <p className="helper-text">
                            BOtag checked whether your other stores can supply part of this reorder before requesting
                            the remaining units from the supplier.
                        </p>

                        <div className="table-scroll">
                            <SupplyBreakdownTable
                                ariaLabel="Reorder supply breakdown by variant"
                                columns={SUPPLY_BREAKDOWN_COLUMNS}
                                rows={SUPPLY_BREAKDOWN_ROWS}
                                footerRow={SUPPLY_BREAKDOWN_TOTALS}
                            />
                        </div>
                    </section>

                    <div className="section-divider"></div>

                    <section className="source-section">
                        <div className="section-label">INTERNAL SOURCE STORES</div>
                        <div className="table-scroll">
                            <SupplyBreakdownTable
                                ariaLabel="Internal source stores"
                                className="supply-table--source-stores"
                                columns={SOURCE_STORE_COLUMNS}
                                rows={SOURCE_STORE_ROWS}
                            />
                        </div>
                    </section>

                    <div className="section-divider"></div>

                    <section className="decision-section" aria-label="Supply options">
                        <div className="request-options">
                            <RequestOption label="Transfer internally when available" />
                            <RequestOption label="Request remaining units from supplier" />
                        </div>
                    </section>
                </main>

                <footer className="footer-actions">
                    <PopupButton text="CLOSE" width="164px" onClick={handleClosePopup} />
                    <PopupButton text="APPLY" width="164px" onClick={handleApplyClick} />
                </footer>
            </div>
        </StyledReorderSupplyBreakdown>
    );
    // #endregion
}

// #region SMALL COMPONENTS
function SupplyBreakdownTable({ ariaLabel, className = "", columns, rows, footerRow }) {
    const visibleRows = footerRow ? [...rows, { ...footerRow, isFooter: true }] : rows;

    return (
        <div className={`supply-table ${className}`} role="table" aria-label={ariaLabel}>
            <div className="supply-table__labels">
                {visibleRows.map(row => (
                    <div className="supply-table__label-row" key={row.label}>
                        {row.label}
                    </div>
                ))}
            </div>

            <div className="supply-table__matrix">
                <div className="supply-table__header" role="row">
                    {columns.map(column => (
                        <div className="supply-table__cell supply-table__cell--header" role="columnheader" key={column.key}>
                            {column.label}
                        </div>
                    ))}
                </div>

                {visibleRows.map(row => (
                    <div className="supply-table__row" role="row" key={row.label}>
                        {columns.map(column => (
                            <SupplyBreakdownCell column={column} row={row} key={column.key} />
                        ))}
                    </div>
                ))}
            </div>
        </div>
    );
}

function SupplyBreakdownCell({ column, row }) {
    const value = row.values?.[column.key];
    const isFooterCell = row.isFooter ? " supply-table__cell--footer" : "";
    const isStatusCell = column.type === "status" ? " supply-table__cell--status" : "";
    const isInfoCell = column.type === "info" ? " supply-table__cell--info" : "";

    if (column.type === "info") {
        return (
            <div className={`supply-table__cell${isFooterCell}${isInfoCell}`} role="cell">
                {row.showInfo && <InfoCircle className="source-info-icon" />}
            </div>
        );
    }

    return (
        <div className={`supply-table__cell${isFooterCell}${isStatusCell}`} role="cell">
            {column.highlight === "badge" && !row.isFooter ? (
                <span className="supply-table__cell-value--badge">{value}</span>
            ) : (
                value
            )}
        </div>
    );
}

function PopupButton({ text, width, onClick }) {
    const POPUP_BUTTON_TEXT_STYLE = { fontSize: "12px", textTransform: "none" };

    const POPUP_BUTTON_COLORS = {
        normalColor: "var(--Buttons-All-Platforms-Gray-500, #10141b)",
        hoverColor: "var(--Buttons-All-Platforms-Gray-500, #10141b)",
        activeColor: "var(--Buttons-All-Platforms-Gray-500, #10141b)",
        disabledColor: "var(--Buttons-All-Platforms-Gray-500, #10141b)"
    };

    return (
        <BtnLargeSolid
            text={text}
            {...POPUP_BUTTON_COLORS}
            textStyle={POPUP_BUTTON_TEXT_STYLE}
            style={{ width }}
            onClick={onClick}
        />
    );
}

function RequestOption({ label }) {
    return (
        <div className="request-option">
            <CheckboxVector disabled={false} isChecked={true} useGreenColorVariant={true} />
            <span>{label}</span>
        </div>
    );
}
// #endregion
